module.exports = __webpack_public_path__ + "static/img/APIHomepage.f630f601.svg";